{
  "title": "Promotions",
  "subtitle": "Des remises réglées une fois, qui s'appliquent seules, aux dates et sur les ventes choisies.",
  "new": "Nouvelle promotion",
  "empty": {
    "title": "Aucune promotion pour le moment",
    "text": "Une promotion baisse les prix toute seule : en caisse, dans les commandes de la gestion et sur la boutique en ligne."
  },
  "tabs": {
    "all": "Toutes",
    "active": "Actives",
    "scheduled": "Prévues",
    "paused": "En pause",
    "ended": "Terminées"
  },
  "status": {
    "active": "Active",
    "scheduled": "Prévue",
    "paused": "En pause",
    "ended": "Terminée"
  },
  "types": {
    "percent": "Pourcentage",
    "amount": "Montant",
    "fixedPrice": "Prix fixe",
    "buyGet": "Achetez X, obtenez Y",
    "quantity": "Prix par quantité",
    "pack": "Pack",
    "orderPercent": "Pourcentage sur la vente",
    "orderAmount": "Montant sur la vente"
  },
  "targets": {
    "products": "Produits",
    "categories": "Catégories",
    "brands": "Marques",
    "all": "Tout"
  },
  "saleTypes": {
    "retail": "Détail",
    "wholesale": "Gros",
    "both": "Détail et gros"
  },
  "channels": {
    "pos": "Caisse",
    "online": "Boutique en ligne",
    "backOffice": "Gestion"
  },
  "list": {
    "search": "Nom ou code de la promotion",
    "type": "Type",
    "allTypes": "Tous les types",
    "saleType": "Type de vente",
    "allSaleTypes": "Tous les types de vente",
    "noMatch": "Aucune promotion ne correspond à ces filtres.",
    "uses_one": "{{value}} utilisation",
    "uses_many": "{{value}} utilisations",
    "uses_other": "{{value}} utilisations",
    "usesOf": "{{uses}} / {{max}} utilisations",
    "showing_one": "{{first}}–{{last}} sur {{total}} promotion",
    "showing_many": "{{first}}–{{last}} sur {{total}} promotions",
    "showing_other": "{{first}}–{{last}} sur {{total}} promotions"
  },
  "columns": {
    "promotion": "Promotion",
    "offer": "Offre",
    "saleType": "Type de vente",
    "dates": "Dates",
    "status": "Statut"
  },
  "summary": {
    "on": "sur",
    "everything": "tout le catalogue",
    "andMore_one": "{{names}} et {{count}} autre",
    "andMore_many": "{{names}} et {{count}} autres",
    "andMore_other": "{{names}} et {{count}} autres",
    "except_one": "sauf {{count}} produit",
    "except_many": "sauf {{count}} produits",
    "except_other": "sauf {{count}} produits",
    "saleTypes": {
      "retail": "détail",
      "wholesale": "gros",
      "both": "détail et gros"
    },
    "allSites": "tous les sites",
    "between": "du {{from}} au {{to}}",
    "from": "à partir du {{from}}",
    "gives": "donne {{names}}",
    "minQuantity": "à partir de {{quantity}} pièces",
    "minAmount": "à partir de {{amount}}",
    "code": "avec le code {{code}}",
    "tags": "pour les clients avec l'étiquette {{tags}}",
    "maxUses_one": "{{count}} utilisation au total",
    "maxUses_many": "{{count}} utilisations au total",
    "maxUses_other": "{{count}} utilisations au total",
    "maxPerCustomer_one": "{{count}} utilisation par client",
    "maxPerCustomer_many": "{{count}} utilisations par client",
    "maxPerCustomer_other": "{{count}} utilisations par client",
    "pack": "{{offer}} : {{names}}"
  },
  "actions": {
    "more": "Actions pour {{name}}",
    "edit": "Modifier",
    "duplicate": "Dupliquer",
    "pause": "Mettre en pause",
    "resume": "Reprendre",
    "end": "Terminer maintenant",
    "delete": "Supprimer"
  },
  "done": {
    "pause": "{{name}} est en pause.",
    "resume": "{{name}} reprend.",
    "end": "{{name}} est terminée.",
    "delete": "{{name}} a été supprimée."
  },
  "confirm": {
    "end": {
      "title": "Terminer {{name}} maintenant ?",
      "text": "Les prix reviennent à la normale tout de suite. Les ventes passées gardent leur promotion.",
      "action": "Terminer maintenant"
    },
    "delete": {
      "title": "Supprimer {{name}} ?",
      "text": "Aucune vente n'a utilisé cette promotion : elle peut partir définitivement.",
      "action": "Supprimer"
    }
  },
  "form": {
    "newTitle": "Nouvelle promotion",
    "editTitle": "Modifier la promotion",
    "saved": "Promotion enregistrée.",
    "name": "Nom",
    "namePlaceholder": "Soldes de l'Aïd",
    "what": "Que donne-t-elle ?",
    "value": {
      "percent": "Pourcentage de remise",
      "amount": "Montant retiré par pièce",
      "fixedPrice": "Prix de chaque pièce",
      "buyGet": "Remise",
      "quantity": "Pourcentage de remise",
      "pack": "Prix du pack",
      "orderPercent": "Pourcentage sur la vente",
      "orderAmount": "Montant sur la vente"
    },
    "orderHint": "Retiré de toute la vente et réparti sur ses lignes. Les lignes qui ont leur propre promotion restent à part, mais comptent pour le minimum.",
    "onWhat": "Sur quoi ?",
    "findProduct": "Chercher un produit : nom, référence ou code-barres",
    "addCategory": "Ajouter une catégorie",
    "addBrand": "Ajouter une marque",
    "targetRequired": "Choisissez-en au moins un.",
    "exceptions": "Sauf ces produits",
    "findException": "Chercher un produit à exclure",
    "removeItem": "Retirer {{name}}",
    "forWhich": "Pour quelles ventes ?",
    "saleType": "Type de vente",
    "wholesaleHint": "Les prix de gros ont déjà une petite marge : vérifiez que celle-ci reste rentable.",
    "channels": "Canaux",
    "channelRequired": "Choisissez au moins un canal.",
    "sites": "Sites",
    "sitesHint": "Aucun coché : tous les sites. Les sites comptent pour la caisse et la gestion, pas pour la boutique en ligne.",
    "forWhom": "Pour qui ?",
    "code": "Code promo",
    "codeHint": "Vide : elle s'applique seule. Avec un code, seulement sur une vente qui le donne.",
    "customerTags": "Étiquettes clients",
    "customerTagsHint": "Vide : tout le monde. Sinon, les clients qui ont l'une de ces étiquettes.",
    "maxUses": "Utilisations au total",
    "maxUsesHint": "Ventes qu'elle peut servir. Vide : sans limite.",
    "maxPerCustomer": "Utilisations par client",
    "maxPerCustomerHint": "Il faut un client sur la vente. Vide : sans limite.",
    "when": "Quand ?",
    "startsOn": "Premier jour",
    "endsOn": "Dernier jour",
    "endsHint": "Vide : jusqu'à ce que vous la terminiez.",
    "buy": "Achetés",
    "get": "Obtenus",
    "getAt": "Remise",
    "maxSets": "Au plus, par vente",
    "buyGetHint": "100 % : offert. La pièce la moins chère est celle donnée, et sa valeur est répartie sur les lignes : un retour rend ce qui a été payé.",
    "fromQuantity": "À partir de cette quantité",
    "tierPercent": "Pourcentage de remise",
    "removeTier": "Retirer ce palier",
    "addTier": "Ajouter un palier",
    "tiersInvalid": "Les quantités doivent monter d'un palier au suivant.",
    "packItems": "Que contient le pack ?",
    "packHint": "Un produit accepte toutes ses variantes ; scannez un code-barres pour nommer une seule variante. Le pack s’applique tout seul dès que toutes ses pièces sont sur la vente, et son gain est réparti sur leurs lignes.",
    "packMaxHint": "Vide : chaque lot complet fait un pack.",
    "packQuantity": "Nombre de {{name}}",
    "packRetail": "Un pack est réservé aux ventes au détail.",
    "whatTheyBuy": "Qu'achètent-ils ?",
    "whatItGives": "Qu'obtiennent-ils ?",
    "sameProducts": "Les mêmes produits",
    "minQuantity": "À partir de cette quantité",
    "minAmount": "À partir de ce montant",
    "minimumHint": "De ce qu’elle couvre dans la vente. Vide : dès la première pièce.",
    "days": "Jours",
    "daysHint": "Aucun coché : tous les jours.",
    "fromTime": "De",
    "toTime": "À",
    "belowCost": {
      "title_one": "{{value}} produit serait vendu sous son coût",
      "title_many": "{{value}} produits seraient vendus sous leur coût",
      "title_other": "{{value}} produits seraient vendus sous leur coût",
      "text": "{{names}}. Vous pouvez quand même enregistrer : écouler un vieux stock est un vrai besoin.",
      "action": "Enregistrer quand même"
    }
  },
  "product": {
    "hint": "Ce qui baisse ce produit maintenant ou bientôt ; la meilleure s'applique."
  },
  "offer": {
    "free": "{{buy}} achetés, {{get}} offert",
    "reduced": "{{buy}} achetés, {{get}} à −{{percent}} %",
    "order": "{{value}} sur la vente",
    "pack": "Pack à {{price}}"
  },
  "days": {
    "0": "Dim.",
    "1": "Lun.",
    "2": "Mar.",
    "3": "Mer.",
    "4": "Jeu.",
    "5": "Ven.",
    "6": "Sam."
  }
}
